import { KILOWATT, KILOWATT_HOUR } from './../../utils/consts';
import dayjs from 'dayjs'
import { Period, Periods, Title } from './types'
import { MdBarChart, MdList, MdPieChart } from 'react-icons/md'

export const DEFAULTPERIOD = {
  from: dayjs().format('YYYY-MM-DD'),
  to: dayjs().format('YYYY-MM-DD'),
  period: Periods.DAY,
}

export const PERIODS_MAP: Record<string, any> = {
  day: 0,
  week: 1,
  month: 2,
  year: 3,
}

export function getReadableValue(mapperFnc: any, value: string): number {
  return mapperFnc[value] || value
}

export const PERIODS: (Period & Title)[] = [
  // {
  //   title: 'Current',
  //   last_hour: "true",
  //   from: dayjs().format('YYYY-MM-DD'),
  //   to: dayjs().format('YYYY-MM-DD'),
  //   period: Periods.CURRENT,
  // },
  {
    title: '1D',
    from: dayjs().startOf('day').format('YYYY-MM-DD'),
    to: dayjs().format('YYYY-MM-DD'),
    period: Periods.DAY,
  },
  {
    title: '1W',
    from: dayjs().subtract(1, 'week').format('YYYY-MM-DD'),
    to: dayjs().format('YYYY-MM-DD'),
    period: Periods.WEEK,
  },
  {
    title: '1M',
    from: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
    to: dayjs().format('YYYY-MM-DD'),
    period: Periods.MONTH,
  },
  {
    title: '1Y',
    period: Periods.YEAR,
    from: dayjs().subtract(1, 'year').format('YYYY-MM-DD'),
    to: dayjs().format('YYYY-MM-DD'),
  },
]

export const VIEW_AS = [
  { id: 1, name: 'Bar chart', icon: MdBarChart },
  { id: 2, name: 'Pie chart', icon: MdPieChart },
  { id: 3, name: 'List', icon: MdList },
]

export const LOCATIONPARAMS: ['location', 'locationIds'] = ['location', 'locationIds']
export const PERIODPARAMS: ['from', 'to', 'period', 'title', 'last_hour', 'device_id', 'location_id', 'group_id'] = [
  'from',
  'to',
  'period',
  'title',
  'last_hour',
  'device_id',
  'location_id',
  'group_id'
]
export const DASHBOARDPARAMS = [...LOCATIONPARAMS, ...PERIODPARAMS]
export const DEVICEPARAMS = [...DASHBOARDPARAMS, 'device']


export function convertToKW(value: number, unit: string | null | undefined): number {
    if (value == null) return 0;

    const num = value
    if (isNaN(num)) return 0;

    if (!unit) return num;

    switch (unit.toLowerCase()) {
        case 'mw':
        case 'mwh':
            return num * 1000;
        case 'w':
        case 'wh':
            return num / 1000;
        case 'kw':
        case 'kwh':
            return num;
        case 'va':
          return num / 1000
        case 'var':
            return num / 1000
        case 'varh':
            return num / 1000
        default:
            return num;
    }
}

export function convertToKWString(unit: string) {
    const lowerUnit = unit.toLowerCase()
    switch (lowerUnit) {
        case 'mw':
        case 'w':
        case 'kw':
          return KILOWATT;
        case 'wh':
        case 'kwh':
        case 'mwh':
          return KILOWATT_HOUR
        case 'va':
          return "kVA"
        case 'var':
            return "kVAr"
        case 'varh':
            return "kVArh"
        default:
            return unit;
    }
} 